/* ==========================================================================
   CasMarkt v2.0 — item 9, the view-density control.

   "The filter section seems cramped with a lot of white space; space it out,
   make it nicer; maybe the option to change how many you see at a time."

   The spacing is CSS (cm-collection.css §10). This file is only the "how many
   you see at a time" half:

     - reads the choice from localStorage,
     - writes it as --cm-cols / --cm-cols-m plus one class on the grid, which
       is all cm-collection.css §10b needs to widen or narrow the columns,
     - keeps every copy of the control (desktop strip and mobile bar) showing
       the same pressed button.

   Spotlight's own grid--N-col-desktop classes are never touched, so the markup
   the section rendered is exactly what a visitor without JS still gets, and
   facets.js can keep replacing #ProductGridContainer wholesale — the observer
   below simply paints the choice back on.
   ========================================================================== */
(function () {
  'use strict';

  if (window.CMCollectionDensity) return;
  window.CMCollectionDensity = true;

  var KEY_DESKTOP = 'cm_grid_cols';
  var KEY_MOBILE = 'cm_grid_cols_m';
  var ALLOWED_DESKTOP = ['3', '4', '5'];
  var ALLOWED_MOBILE = ['1', '2'];

  var desktopCols = null;
  var mobileCols = null;

  function read(key, allowed) {
    try {
      var value = window.localStorage.getItem(key);
      return allowed.indexOf(value) === -1 ? null : value;
    } catch (e) {
      return null;
    }
  }

  function write(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      /* Private mode: the choice still applies, it just is not remembered. */
    }
  }

  function grids() {
    return document.querySelectorAll('#product-grid.product-grid, .product-grid');
  }

  /* The section's own classes are the defaults, so an untouched control shows
     the layout the theme actually rendered rather than a guess. */
  function defaultsFrom(grid) {
    var out = { d: '4', m: '2' };
    for (var i = 0; i < ALLOWED_DESKTOP.length; i += 1) {
      if (grid.classList.contains('grid--' + ALLOWED_DESKTOP[i] + '-col-desktop')) out.d = ALLOWED_DESKTOP[i];
    }
    if (grid.classList.contains('grid--1-col-tablet-down')) out.m = '1';
    return out;
  }

  function apply() {
    var list = grids();
    for (var i = 0; i < list.length; i += 1) {
      var grid = list[i];
      var fallback = defaultsFrom(grid);
      grid.classList.add('cm-grid--cols');
      grid.style.setProperty('--cm-cols', desktopCols || fallback.d);
      grid.style.setProperty('--cm-cols-m', mobileCols || fallback.m);
    }
    syncButtons();
    syncActiveFacets();
  }

  /* v1.7 hid the empty active-filter row with a class written at render time
     (snippets/facets.liquid). facets.js only swaps that row's innerHTML when a
     filter is applied without a page load, so the class went stale and the
     first chip — and "Clear all" with it — stayed invisible until a reload.
     The class is now derived from what the row actually holds. */
  function syncActiveFacets() {
    document.querySelectorAll('.facets__form > .active-facets').forEach(function (row) {
      row.classList.toggle('cm-facets-empty', !row.querySelector('.active-facets__button'));
    });
  }

  function syncButtons() {
    var list = grids();
    var fallback = list.length ? defaultsFrom(list[0]) : { d: '4', m: '2' };
    var d = desktopCols || fallback.d;
    var m = mobileCols || fallback.m;

    document.querySelectorAll('[data-cm-cols]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.getAttribute('data-cm-cols') === d ? 'true' : 'false');
    });
    document.querySelectorAll('[data-cm-cols-m]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.getAttribute('data-cm-cols-m') === m ? 'true' : 'false');
    });
  }

  /* Delegated, so the buttons keep working after facets.js re-renders the
     strip on a filter change. */
  function onClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var button = target.closest('[data-cm-cols], [data-cm-cols-m]');
    if (!button) return;

    event.preventDefault();
    var wide = button.getAttribute('data-cm-cols');
    if (wide && ALLOWED_DESKTOP.indexOf(wide) !== -1) {
      desktopCols = wide;
      write(KEY_DESKTOP, wide);
    }
    var narrow = button.getAttribute('data-cm-cols-m');
    if (narrow && ALLOWED_MOBILE.indexOf(narrow) !== -1) {
      mobileCols = narrow;
      write(KEY_MOBILE, narrow);
    }
    apply();
  }

  function watchGrid() {
    if (typeof MutationObserver === 'undefined') return;

    var pending = null;
    var repaint = function () {
      window.clearTimeout(pending);
      pending = window.setTimeout(apply, 30);
    };

    // facets.js replaces #ProductGridContainer wholesale and rewrites the
    // strip's innerHTML in place, so both are watched: childList only, because
    // apply() writes classes and attributes and would otherwise re-trigger.
    var container = document.getElementById('ProductGridContainer');
    if (container) new MutationObserver(repaint).observe(container, { childList: true, subtree: true });

    var strip = document.querySelector('.facets-container');
    if (strip) new MutationObserver(repaint).observe(strip, { childList: true, subtree: true });
  }

  function init() {
    desktopCols = read(KEY_DESKTOP, ALLOWED_DESKTOP);
    mobileCols = read(KEY_MOBILE, ALLOWED_MOBILE);
    apply();
    watchGrid();
    document.addEventListener('click', onClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
